import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {IdName} from '../domain/id-name.model';

@Injectable()
export class AdStatsDfpService {

  constructor(private http: HttpClient) {
  }

  dfpPubs(): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${environment.serviceUrl}/ad-stats/dfp/pubs`);
  }

  dfpSizes(): Observable<{ fullDisplayString: string }[]> {
    return this.http.get<{ fullDisplayString: string }[]>(`${environment.serviceUrl}/ad-stats/dfp/sizes`);
  }

  dfpPlacements(): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${environment.serviceUrl}/ad-stats/dfp/placements`);
  }
}
